import { ColDef } from 'ag-grid-community';
import { formatDateTime } from '../../utils/date';
import { passwordHistoryByUserId } from '../../api/accountsApi';

/**
 * Function to parse userAgent string
 * @param userAgent - The userAgent string
 * @returns Parsed browser and system information
 */
const parseUserAgent = (userAgent: string): string => {
  const browserMatch = userAgent.match(/(Chrome|Firefox|Safari|Edge|Opera|MSIE|Trident)[\/\s]?([\d.]+)/i);
  const systemMatch = userAgent.match(/\(([^)]+)\)/);
  const browser = browserMatch ? browserMatch[1] : 'Unknown Browser';
  const system = systemMatch ? systemMatch[1].split(';')[0] : 'Unknown System';
  return `${browser}, ${system}`;
};

export const passwordHistoryTableColumns: ColDef[] = [
  { headerName: 'Changed At', field: 'createdAt', valueFormatter: (params) => formatDateTime(params.value), minWidth: 200 },
  { headerName: 'Changed By', field: 'changedBy', minWidth: 200 },
  { headerName: 'Method', field: 'method', minWidth: 600 },
  { headerName: 'IP Address', field: 'ipAddress' },
  {
    headerName: 'User Agent',
    field: 'userAgent',
    valueFormatter: (params) => parseUserAgent(params.value),
  },
];

export const passwordHistoryConfig = {
  entityName: 'Password Change History',
  redirectPath: '/password-history',
  passwordHistoryTableColumns,
  api: {
    list: passwordHistoryByUserId,
  },
};